import axios from "axios";

import Constants from "../../utils/Constantes";

const API_URL = Constants.api_url;

const GET_SERVICIOS_PRESTADOS = `${API_URL}/ceserpre/`;
const GET_NOTA_ACLARATORIA = `${API_URL}/ceserpre/notaAclaratoria`;

export async function getServiciosPrestados() {
  return await axios({
    method: "GET",
    url: `${GET_SERVICIOS_PRESTADOS}`,
  })
    .then((response) => response.data)
    .catch("Error:");
}

export async function getNotaAclaratoria() {
  return await axios({
    method: "GET",
    url: `${GET_NOTA_ACLARATORIA}`,
  })
    .then((response) => response.data)
    .catch("Error:");
}